// Central asset URL registry. Keep image URLs in one place for hygiene.

export const ASSETS = {
  logo:
    "https://static.prod-images.emergentagent.com/jobs/a3f1ac7b-32df-48f9-b08b-6242433766a6/images/3a1e0a14bfb74b87ba5a42dca7d31d525546a15f68fbc454b34a4992b84352ec.jpeg",
  mascot:
    "https://static.prod-images.emergentagent.com/jobs/a3f1ac7b-32df-48f9-b08b-6242433766a6/images/b2aef1c986bfb555ababebfc8b18130ed8e9050aa1092f3afda6f49a94dd422a.jpeg",
  mascotOllie:
    "https://static.prod-images.emergentagent.com/jobs/a3f1ac7b-32df-48f9-b08b-6242433766a6/images/b2aef1c986bfb555ababebfc8b18130ed8e9050aa1092f3afda6f49a94dd422a.jpeg",
  scene:
    "https://static.prod-images.emergentagent.com/jobs/a3f1ac7b-32df-48f9-b08b-6242433766a6/images/f7c86fca847f6ed295f190ff17c22560ddd98448bbcf4537e3a4ed1a7cb6c4d7.jpeg",
  avatarSet:
    "https://static.prod-images.emergentagent.com/jobs/a3f1ac7b-32df-48f9-b08b-6242433766a6/images/29aa991961c00a131b78b6b6a8ab2966fa7a3503f4a9cab63045cecab4851029.jpeg",
};

export const AVATAR_EMOJI = {
  fox: "🦊",
  bear: "🐻",
  bunny: "🐰",
  cat: "🐱",
  frog: "🐸",
  panda: "🐼",
};

export function avatarLabel(slug) {
  return AVATAR_EMOJI[slug] || "🐾";
}
